<template>
  <div>
    <wc-page-title title='Dashboard'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box
            title='All Lawn Projects'
            :titleIcon='lawnDivision.icon'
            :titleIconColor='lawnDivision.icon_color'
            :loading='isLoading'
          >
            <template v-slot:toolbarButtons>
              <wc-show-archived-button
                v-model='showArchived'
                @toggleShowArchived='showArchived = !showArchived'
              ></wc-show-archived-button>
              <wc-toolbar-search v-model='search'></wc-toolbar-search>
            </template>
            <v-data-table
              dense
              :headers='headers'
              :items='filteredProjects'
              :search='search'
              :items-per-page='25'
              sort-by='name'
              no-data-text='No Lawn Projects Found'
              @click:row='openProject'
            >
              <template v-slot:item.name='{ item }'>
                {{ item.name }}
                <wc-archived v-if='item.archived'></wc-archived>
              </template>
              <template v-slot:item.start_date='{ item }'>
                {{ item.start_date | shortDate }}
              </template>
              <template v-slot:item.end_date='{ item }'>
                {{ item.end_date | shortDate }}
              </template>
            </v-data-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';
import projectsAPI from '@/modules/projects/api/projects';

export default {
  name: 'lawn-dashboard',
  data: () => ({
    isLoading: true,
    showArchived: false,
    projects: [],
    search: '',
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Number', value: 'number' },
      { text: 'Address', value: 'site_address' },
      { text: 'City', value: 'site_city' },
      { text: 'Start Date', value: 'start_date', align: 'center' },
      { text: 'End Date', value: 'end_date', align: 'center' }
    ]
  }),
  mounted () {
    this.getProjects()
  },
  computed: {
    lawnDivision () {
      return this.$store.state.misc.divisions.find(d => d.division === 'Lawn')
    },
    filteredProjects () {
      return this.showArchived ? this.projects : _.filter(this.projects, p => !p.archived)
    },
  },
  methods: {
    async getProjects () {
      this.isLoading = true
      this.projects = await projectsAPI.getDivisionProjects(this.lawnDivision)
      this.isLoading = false
    },
    openProject (item) {
      this.$router.push({ name: 'LawnOverview', params: { id: item.id } })
    }
  }
}
</script>